import script from "./ImportProgramHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportProgramHistory.vue?vue&type=script&setup=true&lang=js"

import "./ImportProgramHistory.vue?vue&type=style&index=0&id=61bffbea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61bffbea"]])

export default __exports__